/* unplugin-vue-components disabled */import { render } from "./NotificationPageApp.vue?vue&type=template&id=ad13e428&scoped=true&ts=true"
import script from "./NotificationPageApp.vue?vue&type=script&lang=ts"
export * from "./NotificationPageApp.vue?vue&type=script&lang=ts"

import "./NotificationPageApp.vue?vue&type=style&index=0&id=ad13e428&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad13e428"]])

export default __exports__